import React from "react";
import { Field } from "types";
import { FormField } from "../Field/FormField";
import { InputField, InputProps } from "../Field/InputField";
import { QuestionnaireDescription } from "./QuestionnaireDescription";

export interface FieldProps extends InputProps {
    name: string;
    field: Field;
    initialValue?: string;
    isRequired?: boolean;
    classNames?: {
        label?: string;
        description?: string;
    };
}

export const TextField = ({ name, field, classNames, ...rest }: FieldProps) => {
    return (
        <FormField label={field.label} name={name} classNames={{ label: classNames?.label }}>
            <QuestionnaireDescription field={field} />
            <InputField {...rest} />
        </FormField>
    );
};
